<template>
	<div>
		<!-- 登录信息 -->
		<global-tips></global-tips>
		<el-card>
			<!-- 搜索框 -->
			 <el-form v-show="showSearch" ref="queryForm" :model="queryForm" inline size="small">
				<el-form-item label="名称" label-width="50px" prop="keyword">
				  <el-input v-model="queryForm.keyword" placeholder="请输入名称" type="text" clearable style="width: 230px" />
				</el-form-item>
				<el-form-item>
				  <el-button type="primary" icon="el-icon-search" size="mini" @click="query">查询</el-button>
				  <el-button icon="el-icon-refresh" size="mini" @click="resetQuery('queryForm')">重置</el-button>
				</el-form-item>
			</el-form>
			<!--自定义刷新组件-->
			<el-row :gutter="10" class="mb-1">
				<!-- <el-button type="primary" icon="el-icon-plus" size="mini" @click="handleAdd">新增</el-button> -->
				<right-toolbar :show-search.sync="showSearch" @queryTable="query" />
			</el-row>
			<!--表格-->
			 <el-table
				v-loading="loading"
				size="small"
				:data="list"
				element-loading-text="Loading"
				highlight-current-row
				style="width: 100%"
			 >
				<el-table-column label="序号" width="80" align="center">
				  <template slot-scope="scope">
					{{ (queryForm.page - 1) * queryForm.limit + scope.$index + 1 }}
				  </template>
				</el-table-column>
				<el-table-column label="门店名称" min-width="110" align="center">
				  <template slot-scope="scope">
					<span>{{ scope.row.store_name }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="用户名称" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.nickname }}
				  </template>
				</el-table-column>
				<el-table-column label="分红天数" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.day }}
				  </template>
				</el-table-column>
				<el-table-column label="剩余天数" min-width="110" align="center">
				  <template slot-scope="scope">
					{{ scope.row.rem_day }}
				  </template>
				</el-table-column>
				<el-table-column label="状态" min-width="70" align="center">
				  <template slot-scope="scope">
					<el-tag v-if="scope.row.rem_day != 0" size="mini" type="success">正常</el-tag>
					<el-tag v-if="scope.row.rem_day == 0" size="mini" type="danger">已完成</el-tag>
				  </template>
				</el-table-column>
				<el-table-column align="center" prop="utime" label="时间" min-width="170">
				  <template slot-scope="scope">
					<i class="el-icon-time" />
					<span>{{ scope.row.ctime }}</span>
				  </template>
				</el-table-column>
				<el-table-column label="操作" min-width="100" align="center" fixed="right">
				  <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" content="明细" placement="top">
					  <el-button type="success" icon="el-icon-view" size="mini" circle @click="recordQuery(scope.row)"></el-button>		
					</el-tooltip>
	<!-- 				<el-tooltip class="item" effect="dark" content="编辑" placement="top">
					  <el-button type="success" icon="el-icon-edit" size="mini" circle @click="handleEdit(scope.row)"></el-button>		
		            </el-tooltip>
					<el-tooltip class="item" effect="dark" content="删除" placement="top">
					  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="handleDelete(scope.row.id)"></el-button>		
					</el-tooltip> -->
				  </template>
				</el-table-column>
			 </el-table>
			 <pagination
				:total="total"
				auto-scroll
				:page.sync="queryForm.page"
				:limit.sync="queryForm.limit"
				@pagination="query"
			 />
		</el-card>
		<!-- 编辑-->
		<el-dialog :visible.sync="open" width="600px" :close-on-click-modal="false" append-to-body :title="title">
		  <el-form ref="form" :model="form" :rules="rules" label-width="80px" size="small">
		    <el-form-item label="名称" prop="username">
		      <el-input v-model="form.username" placeholder="请输入名称" type="text" clearable />
		    </el-form-item>
		    <el-form-item label="密码" prop="password">
		      <el-input v-model="form.password" placeholder="请输入密码" type="password" clearable />
		    </el-form-item>
		    <el-form-item label="电话" prop="mobile">
		      <el-input v-model="form.mobile" placeholder="请输入电话" type="text" clearable />
		    </el-form-item>
		   <el-form-item  label="状态">
		      <el-radio-group v-model="form.status">
		      	<el-radio :label="1">使用</el-radio>
		      	<el-radio :label="2">停用</el-radio>
		      </el-radio-group>
		    </el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button size="mini" @click="cancel">取 消</el-button>
		    <el-button type="primary" size="mini" @click="handleSubmit">确 定</el-button>
		  </div>
		</el-dialog>
		<!-- 日志列表 -->
		 <el-dialog
			 :visible.sync="record_open"
			 width="1000px"
			 :close-on-click-modal="false"
			 append-to-body
			 title="日志"
		   >
			 <el-table
			   v-loading="listLoading"
			   size="small"
			   :data="recordList"
			   element-loading-text="Loading"
			   highlight-current-row
			   style="width: 100%"
			 >
			   <el-table-column label="ID" width="80" align="center">
				 <template slot-scope="scope">
				   {{ scope.row.id }}
				 </template>
			   </el-table-column>
			   <el-table-column label="描述" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.memo }}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="变更数量" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.money || 0}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="余额" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.balance || 0}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column label="分红用户" align="center">
				 <template slot-scope="scope">
				   <span>{{ scope.row.nickname || 0}}</span>
				 </template>
			   </el-table-column>
			   <el-table-column align="center" label="变更时间">
				 <template slot-scope="scope">
				   <span>{{ scope.row.ctime }}</span>
				 </template>
			   </el-table-column>
			 </el-table>
			 <pagination
			   :total="recordForm.total"
			   auto-scroll
			   :page.sync="recordForm.page"
			   :limit.sync="recordForm.limit"
			   @pagination="recordQuery"
			 />
			 <div slot="footer" class="dialog-footer"></div>
		</el-dialog>
	</div>
</template>

<script>
	import GlobalTips from "@/components/GlobalTips";
	import common from "@/common/mixins/common.js"
	export default {
		inject:['app'],
		mixins:[common],
		components: {
			GlobalTips,
		},
		data() {
			return {
				preUrl: 'lj_fh',
				queryForm: {
					page: 1,
					limit: 10,
					keyword: '',
				},
				form:{
					username:'',
					password:'',
					mobile:'',
					role_ids:[],
					status:1,
					avatar:'',
					url:'',
				},
				rules:{
					username: [
					  { required: true, message: '请输入名称', trigger: 'blur' }
					],
					role_ids: [
					  { required: true, message: '请选择角色', trigger: ['blur', 'change'] }
					],
				},
				record_open:false,
				recordList:[],
				listLoading: false,
				recordForm: {
					page: 1,
					limit: 10,
					total:0,
					name:'',
					id:'',
				},
			}
		},
		mounted() {
			
		},
		methods:{
			reset() {
			  this.form = {
			   username:'',
			   password:'',
			   mobile:'',
			   role_ids:[],
			   status:1,
			   avatar:'',
			   url:'',
			  }
			  this.resetForm('form')
			},
			recordQuery(item){
				 this.record_open = true;
				 this.recordList = [];
				 if(item.id){
					 this.recordForm.id = item.id
				 }
				 this.axios.get('/manage/lj_fh/recordList',{
				   params:this.recordForm
				 }).then(res=>{
				   if(res.status){
					 this.recordList = res.data.data
					 this.recordForm.total = res.data.total
				   }
				 })
			},
		}
	}
</script>

<style>
</style>